// The one sync engine of the running app, wired to the real network, storage,
// settings and page. Created on first use; tests can swap in their own.

import { apiFor } from '../api/endpoints';
import { snapshotStore } from '../cache/snapshot';
import { currentLeague } from '../league/league';
import { getSetting, settings, subscribeSetting } from '../settings/settings';
import { sessionGet, sessionSet } from '../settings/storage';
import { createSyncEngine, type SyncEngine } from './syncEngine';

let engine: SyncEngine | undefined;

export function getEngine(): SyncEngine {
    if (engine === undefined) {
        // The league is fixed for the page load (see core/league).
        const league = currentLeague();
        const snapshots = snapshotStore(league === 'AHL' ? 'AHL_' : '');
        const created = createSyncEngine({
            api: apiFor(league),
            getCountry: () => getSetting(settings.country),
            loadSnapshot: country => snapshots.load(country),
            saveSnapshot: snapshots.save,
            reload: () => window.location.reload(),
            isVisible: () => document.visibilityState !== 'hidden',
            now: () => Date.now(),
            sessionGet,
            sessionSet,
        });
        // The country setting is the source of truth, also across tabs.
        subscribeSetting(settings.country, () => created.setCountry(getSetting(settings.country)));
        engine = created;
    }
    return engine;
}

export function setEngineForTests(replacement: SyncEngine | undefined): void {
    engine = replacement;
}
